import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { channel } from "../../../../../../redux/channel/action";
import { selectChannelListItems } from "../../../../../../redux/channel/selector";

const ManagementChannels = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
    const channelItems = useSelector(selectChannelListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
      { field: 'StoreSalesChannelPId', headerName: 'SalesChannelPId' },
      { field: 'SalesChannelName', headerName: 'SalesChannelName' },
      { field: 'DisplayOrder', headerName: 'DisplayOrder' },
      { field: 'IsActive', headerName: 'Active', cellRenderer: 'yesNoRenderer' }
      
        ]);
      }
      const fetchChannels=()=>{

      	dispatch(channel.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/channels/list`,entity:'channel',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
       
      }
	useEffect(() => {
        createColumnDefs()
        fetchChannels()
	}, [pageData])
  const additionButtons: any = [
    {
      name: 'Go To Stores',
      callback: () => handleStores(),
    }
  ];
  const handleStores=()=>{
    navigate('/management/organization/organization-management/stores')
  }
  const handleEdit=(data: any)=>{
    navigate(`${data?.Id}`)
  }

const handleDelete=(data: any)=>{
} 
	return (
    <>
    {channelItems?.isLoading ? 
    <PageLoader />
    :   
		<Table columnData={columnDefs} rowData={channelItems?.result?.items} setPageData={setPageData}
    paginationData={channelItems?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Channels"  />
  }
  </> 
     
	);
};

export default ManagementChannels;


